import Vue from "vue";
import VueResource from "vue-resource";
import hub from "./scripts/_hub.js";
import App from "./App.vue";
import "@/styles/site.less";
import router from "./router"
import VueTippy, {
	TippyComponent
} from "vue-tippy";
import VueCookies from "vue-cookies";
import "tippy.js/themes/light.css";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import Modals from './scripts/_modals';
import store from "./store";

Vue.use(Modals);
Vue.use(VueTippy);
Vue.use(VueResource);
Vue.use(VueCookies, {
	expire: '7d'
});

require("./scripts/_filters.js");
require("./scripts/_directives.js");

Vue.config.productionTip = false;

// components
Vue.component("d21-select", function (resolve, reject) {
	require(["./components/ui/select.vue"], resolve);
});

Vue.component("d21-switcher", function (resolve, reject) {
	require(["./components/ui/switch.vue"], resolve);
});

Vue.component("d21-toggler", function (resolve, reject) {
	require(["./components/ui/toggler.vue"], resolve);
});

Vue.component("tippy", TippyComponent);

new Vue({
	data() {
		return {
			hub: hub
		}
	},
	render: h => h(App),
	router,
	store,
	beforeMount() {
		// init hub
		let self = this;
		self.hub.init(this);
	},
}).$mount("#app")

window.hub = hub;